import { PERMISSIONS } from '@loot/shared';
import { useTranslation } from 'react-i18next';
import { useMe } from '../auth.tsx';
import { PageHeader, Panel } from '../components/ui.tsx';
import { localized } from '../i18n/index.ts';

const LABELS = new Map(PERMISSIONS.map((p) => [p.code as string, p.label]));

/**
 * Meus acessos: o que a pessoa pode fazer no sistema e em quais escopos. Abre pelo nome dela no
 * rodapé da lateral (ADR 0071); saiu do Início, que fica com o conteúdo da empresa e o dia a dia.
 */
export function MyAccessPage() {
  const { t } = useTranslation();
  const { data: me } = useMe();
  if (!me) return null;
  return (
    <>
      <PageHeader title={t('myAccess.title')} description={t('myAccess.description')} />
      <Panel>
        {me.permissions.length === 0 ? (
          <p className="text-sm text-muted">{t('myAccess.empty')}</p>
        ) : (
          <ul className="flex flex-col gap-1 text-sm">
            {me.permissions.map((p) => (
              <li key={p.permission} className="flex flex-wrap items-baseline gap-2">
                <span>{localized(LABELS.get(p.permission)) || p.permission}</span>
                <span className="text-xs text-muted">
                  {p.scopes.map((s) => t(`scope.${s.scopeType}`)).join(', ')}
                </span>
              </li>
            ))}
          </ul>
        )}
      </Panel>
    </>
  );
}
